import React, { useEffect, useState } from "react";
import UserActionHistoryClient from "../../../api-services/user-action-history/user-action-history-client";
import LawAdActClient from "../../../api-services/law-ad-act/law-ad-act-client";
import Table from "../../../../common/table/Table.component";
import HandlingResponse from "../../../../common/handling-response/handlingResponse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { format } from "date-fns";
import { DownloadButton } from "../../../../common/multiple-files/multipleFiles.style";

const UserHistoryAction = ({ isAct, id, tableName, reload }) => {
  const userActionHistoryClient = new UserActionHistoryClient();
  const lawAdActClient = new LawAdActClient();

  const ActionStatusEnum = {
    UpdateLawAdActFileAndMetadata: 0,
    UpdateLawAdActMetadata: 1,
    UpdateLawAdActFile: 2,
    UpdateNumberWithFileAndPublishDate: 3,
    UpdateNumberPublishDate: 4,
    UpdateNumberFile: 5,
    PublishedNumber: 6,
    UnpublishedNumber: 7,
    DeletedFilesAndUpdatedMetadata: 8,
  };

  const columns = [
    {
      Header: "Id",
      accessor: "id",
    },
    {
      Header: "Корисничко име",
      accessor: "username",
    },
    {
      Header: "Информације о броју",
      accessor: "numberInfo",
    },
    {
      Header: "Назив акта",
      accessor: "lawAdActName",
    },
    {
      Header: "Датум објављивања",
      accessor: "publishDate",
      Cell: ({ row }) => {
        const parsedDate = Date.parse(row.original.publishDate);
        return parsedDate ? format(parsedDate, "dd.MM.yyyy.") : "";
      },
    },
    {
      Header: "Време измене",
      accessor: "creationDate",
      Cell: ({ row }) => {
        const parsedDate = Date.parse(row.original.creationDate);
        return format(parsedDate, "dd.MM.yyyy. HH:mm");
      },
    },
    {
      Header: "Тип измене",
      accessor: "actionStatus",
      Cell: ({ row }) => {
        return row.original.actionStatus ===
          ActionStatusEnum.UpdateLawAdActFileAndMetadata
          ? "Измењен фајл и могућа измена метаподатака"
          : row.original.actionStatus ===
            ActionStatusEnum.UpdateLawAdActMetadata
          ? "Измењени метаподаци"
          : row.original.actionStatus === ActionStatusEnum.UpdateLawAdActFile
          ? "Измењен фајл преко едитора"
          : row.original.actionStatus ===
            ActionStatusEnum.UpdateNumberWithFileAndPublishDate
          ? "Измењен фајл и датум објављивања"
          : row.original.actionStatus ===
            ActionStatusEnum.UpdateNumberPublishDate
          ? "Измењен датум објављивања"
          : row.original.actionStatus === ActionStatusEnum.UpdateNumberFile
          ? "Измењен фајл"
          : row.original.actionStatus === ActionStatusEnum.PublishedNumber
          ? "Објављено гласило"
          : row.original.actionStatus === ActionStatusEnum.UnpublishedNumber
          ? "Одјављено гласило"
          : row.original.actionStatus ===
            ActionStatusEnum.DeletedFilesAndUpdatedMetadata
          ? "Обрисан фајл и могућа измена метаподатака"
          : "";
      },
    },
    {
      accessor: "download",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          (row.original.htmlGuid || row.original.pdfGuid) && (
            <DownloadButton
              title="Преузми фајл"
              type="button"
              onClick={() =>
                isAct
                  ? downloadHistoryActionLawAct(
                      row.original.htmlGuid,
                      row.original.lawAdActName
                    )
                  : downloadHistoryActionNumber(
                      row.original.pdfGuid,
                      row.original.pdfName
                    )
              }
            >
              <FontAwesomeIcon icon={solid("download")} />
            </DownloadButton>
          )
        );
      },
    },
  ];
  const [listOfHistoryAction, setListOfHistoryAction] = useState([]);

  useEffect(() => {
    if (!id) return;
    isAct ? GetUserActionHistoryLawAct(id) : GetUserActionHistoryNumber(id);
  }, [id, reload]);

  const GetUserActionHistoryNumber = async (lawActId) => {
    const response = await userActionHistoryClient.GetUserActionHistoryNumber(
      lawActId
    );
    if (response !== "Error") {
      setListOfHistoryAction(HandlingResponse(response));
    }
  };
  const GetUserActionHistoryLawAct = async (actId) => {
    const response = await userActionHistoryClient.GetUserActionHistoryLawAct(
      actId
    );
    if (response !== "Error") {
      setListOfHistoryAction(HandlingResponse(response));
    }
  };

  const downloadHistoryActionNumber = async (guid, name) => {
    var response = await lawAdActClient.DownloadMainFile(guid, name);
    HandlingResponse(response);
  };

  const downloadHistoryActionLawAct = async (guid, name) => {
    var response = await lawAdActClient.DownloadFilesFromRepoByHtmlGuid(
      guid,
      name
    );
    HandlingResponse(response);
  };

  return (
    <div>
      <Table
        columns={columns}
        data={listOfHistoryAction || []}
        tableName={tableName}
        serverSide={false}
        rememberFilter={false}
        hiddenColumn={
          isAct ? ["id", "numberInfo", "publishDate"] : ["id", "lawAdActName"]
        }
      />
    </div>
  );
};

export default UserHistoryAction;
